import Dropdown from "app/components/Dropdown";
import { CheckIcon } from "app/components/Icons";
import {
  IDropdownOptions,
} from "app/containers/Features/containers/TeamSettings/container/Projects/container/CustomFields/types";
import clsx from "clsx";
import React from "react";

interface Props {
  onChange: (val: string) => void;
  value: string;
  error?: string;
  options: IDropdownOptions[];
}

const DropdownNameSelect: React.FC<Props> = ({
  onChange,
  value,
  error,
  options,
}) => {
  const MenuItems = options?.map((ele) => {
    if (ele)
      return {
        label: (
          <div className={`flex gap-2 w-[100%] items-center justify-between`}>
            <span className="text-sm font-medium text-black truncate">
              {ele?.value}
            </span>
            {ele?.value === value && <CheckIcon color="#5A8DF1" />}
          </div>
        ),
        action: () => {
          onChange(ele.value);
        },
      };
    else return { label: "", action: () => {} };
  });

  return (
    <div className="w-full relative h-full ">
      <Dropdown
        trigger={
          <button
            className={clsx(
              "h-[42px] w-full min-h-max data-[state=open]:border-secondary data-[state=open]:outline-secondary data-[state=open]:border text-start px-3 text-sm text-black",
              error && "border-danger",
            )}
          >
            <div className="relative">
              {value ? value : <span className="text-muted-foreground">-</span>}
            </div>
          </button>
        }
        projectInfoIcon={
          <div className="flex items-center justify-between px-4 h-[50px] text-secondary text-sm font-semibold leading-[21px] uppercase border-b border-gray-100 ">
            <span> SELECT AN OPTIONS</span>
          </div>
        }
        menuItems={MenuItems}
      />
    </div>
  );
};

export default DropdownNameSelect;

